export default __webpack_public_path__ + "static/media/approved.3f77cb4f.png";